import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import { QuoteHero, QuoteEmbed } from '../components/QuotePageSections';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const QuotePage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Get a Quote - Electrician Carrum & Bayside"
        description="Request a free quote for electrical or security services in Carrum and Bayside Melbourne. Fast response from our licensed team."
        keywords="electrical quote Carrum, security quote Bayside Melbourne, free quote electrician, CCTV quote Melbourne"
        canonical="https://securelec.net.au/get-a-quote"
      />
      <Header />
      <main>
        <QuoteHero />
        <QuoteEmbed />
      </main>
      <Footer />
    </div>
  );
};

export default QuotePage;
